export default {
	wrapper: {
		position: 'relative',
		textAlign: 'center',
	},
	platformName: {
		color: '#3C4858',
		fontSize: '18px',
		margin: '22px auto 15px',
	},
	notificationText: {
		position: 'absolute',
		textAlign: 'left',
		fontSize: '11px',
		fontWeight: '500',
		lineHeight: 'initial',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		lineClamp: 1,
		display: '-webkit-box',
		'-webkit-box-orient': 'vertical',
	},
	notificationImage: {
		objectFit: 'contain',
		position: 'absolute',
	},

	// ios
	iosTemplate: {
		maxHeight: '634px',
	},
	iosNotificationTitle: {
		top: '377px',
		left: '34px',
		right: '34px',
	},
	iosNotificationImage: {
		top: '192px',
		left: '27px',
		height: '172px',
		width: '265px',
	},
	iosNotificationText: {
		top: '392px',
		left: '34px',
		right: '34px',
	},

	// android
	androidTemplate: {
		maxHeight: '634px',
	},
	androidNotificationTitle: {
		top: '225px',
		left: '25px',
		right: '25px',
	},
	androidNotificationImage: {
		top: '270px',
		left: '24px',
		height: '130px',
		width: '250px',
	},
	androidNotificationText: {
		top: '240px',
		left: '25px',
		right: '25px',
	},
};
